<script>
import { DoubleBounce } from 'vue-loading-spinner';
import VueHtml2pdf from 'vue-html2pdf';
import settingsService from '@/services/Settings/settingsService';
import { jsPDF } from "jspdf";


export default {
  name: 'contrato-modelo-socinal',
  props: {
    error: {
      type: String,
      default: undefined,
    },
    title: {
      type: String,
      required: false,
      default: 'CÉDULA DE CRÉDITO BANCÁRIO',
    },
    objeto: {
      type: Object,
      required: true
    },
  },
  filters: {
    formatarCNPJ(cnpj) {
      // Verifica se o CNPJ é válido
      if (!cnpj) {
        console.log('CNPJ não fornecido');
        return '';
      }
      cnpj = cnpj.toString().replace(/[^\d]/g, '');
      if (cnpj.length !== 14) {
        console.log('CNPJ inválido:', cnpj);
        return cnpj;
      }

      // Formata o CNPJ
      const cnpjFormatado = cnpj.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
        '$1.$2.$3/$4-$5'
      );
      console.log('CNPJ formatado:', cnpjFormatado);
      return cnpjFormatado;
    }
  },
  data() {
    return {
      LETTER_SPACING: '0.08rem',
      isLoading: false,
      pdfContract: "",
      downloadPDF: false,
      isBancarizadorManual: false,
      isBancarizadorEagle: false,
      procurador: {
        razao_social: "",
        cnpj: ""
      }
    };
  },
  computed: {},
  components: {
    DoubleBounce,
    VueHtml2pdf
  },
  methods: {
    createPDF(downloadPDF = true) {
      this.isLoading = true;
      this.downloadPDF = downloadPDF;

      const termoEndossoElement = document.getElementById('termoEndosso');
      termoEndossoElement.style.marginTop = '550px';
    
      const doc = new jsPDF('p', 'pt', 'A4');
      doc.html(document.querySelector("#pdfContrato"), {
        callback: function (doc) {
          doc.save('Contrato_CCB.pdf');
        },
        margin: [30, 20, 30, 20],
        autoPaging: 'text',
        width: 1024,
        height: 842,
        windowWidth: 1024,
        html2canvas: {
          scale: 0.55,
        },
      });
      this.isLoading = false;
      setTimeout(() => {
        termoEndossoElement.style.marginTop = '0px';
      }, 6000)
      },
    downloadContratoCCB(downloadPDF = true) {
      this.isLoading = true;
      this.downloadPDF = downloadPDF;
      this.$refs.html2Pdf.generatePdf();
      this.isLoading = false;
    },
    async loadImage(url, callback) {
      var img = new Image();
      img.setAttribute('crossOrigin', 'anonymous');
      img.addEventListener('load', () => {
        var canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;

        var context = canvas.getContext('2d');
        context.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL('image/jpeg');
        callback(dataURL);
      });
      img.src = url.replace("http://", "//");
      img.onerror = function () {
        console.log('on error')
        callback('');
      };
    },
    async beforeDownload({ options }) {
      let that = this;

      var optionsPdf = options;
      optionsPdf.enableLinks = true;
      optionsPdf.margin = [1.1, 0, 1, 0];
      optionsPdf.pageBreak = { mode: ['avoid-all', 'css'] };
      optionsPdf.html2canvas = {
        scale: 1
      };

      const doc = new jsPDF('p', 'pt', 'A4');
      doc.html(document.querySelector("#pdfContrato"), {
        callback: function (doc) {
          that.$emit('pdfContratoCCBGenerated', doc.output('datauristring', { filename: 'Contrato_CCB.pdf' }));
        },
        margin: [30, 20, 30, 20],
        autoPaging: 'text',
        width: 1024,
        height: 842,
        windowWidth: 1024,
        html2canvas: {
          scale: 0.55,
        },
      });

      // this.loadImage(this.objeto.credor.logotipo_url, async function (img) {
      //   // var imgViaNegociavel = new Image();
      //   // imgViaNegociavel.src = require('@/assets/images/via_negociavel.png');
      //   if (that.downloadPDF) {
      //     await html2pdf().set(optionsPdf).from(pdfContent).toPdf().get('pdf').then((pdf) => {
      //       const totalPages = pdf.internal.getNumberOfPages()
      //       for (let i = 1; i <= totalPages; i++) {
      //         pdf.setPage(i);
      //         pdf.setFontSize(10);
      //         pdf.setTextColor(150);

      //         let coordX = (pdf.internal.pageSize.getWidth() * 0.88);
      //         let coordY = (pdf.internal.pageSize.getHeight() - 0.3);
      //         pdf.text('Pág.: ' + i + ' de ' + totalPages, coordX, coordY);
      //         pdf.addImage(img, 'PNG', 0.45, 0.6, 1.4, 0.5);

      //         // pdf.addImage(imgViaNegociavel, 'PNG', 1.5, 2, 9, 12);
      //       }
      //     }).save();
      //   }
      //   else {
      //     await html2pdf().set(optionsPdf).from(pdfContent).toPdf().get('pdf').then((pdf) => {
      //       const totalPages = pdf.internal.getNumberOfPages()
      //       for (let i = 1; i <= totalPages; i++) {
      //         pdf.setPage(i);
      //         pdf.setFontSize(10);
      //         pdf.setTextColor(150);

      //         let coordX = (pdf.internal.pageSize.getWidth() * 0.88);
      //         let coordY = (pdf.internal.pageSize.getHeight() - 0.3);
      //         pdf.text('Pág.: ' + i + ' de ' + totalPages, coordX, coordY);
      //         try {
      //           // pdf.addImage(img, 'PNG', 0.45, 0.6, 1.4, 0.5);
      //         }
      //         catch (error) {
      //           pdf.addImage(img, 'PNG', 0.45, 0.6, 1.4, 0.5);
      //         }
      //       }
      //     }).output('datauristring').then(function (pdfAsString) {
      //       that.$emit('pdfContratoCCBGenerated', pdfAsString);
      //     });
      //   }
      //   that.isLoading = false;
      // });
    }
  },
  async mounted() {
    let that = this;
    let privateSettings = await settingsService.getPrivateSettings();
    this.isBancarizadorManual = privateSettings.is_bancarizador_manual != undefined ? privateSettings.is_bancarizador_manual : false;
    this.isBancarizadorEagle = privateSettings.is_bancarizador_eagle != undefined ? privateSettings.is_bancarizador_eagle : false;
    this.procurador.razao_social = privateSettings.razao_social;
    this.procurador.cnpj = privateSettings.cnpj;

    setTimeout(function () {
      that.downloadContratoCCB(false);
    }, 1000);
  }
};
</script>

<template>
  <div style="max-width: 800;">
    <div class="row download-contrato" id="ignorePDF">
      <div class="col-md-12 text-right">
        <button class="btn btn-primary" @click="createPDF">
          DOWNLOAD
          <i class="fas fa-download"></i>
        </button>
      </div>
    </div>
    <div class="download-contrato-loading" v-if="isLoading">
      <double-bounce class="download-contrato-loading-bounce"></double-bounce>
    </div>

    <vue-html2pdf :show-layout="false" :float-layout="false" :enable-download="false" :preview-modal="false"
      filename="Contrato CCB" :pdf-quality="2" :manual-pagination="true" pdf-format="a4" pdf-orientation="portrait"
      pdf-content-width="100%" @beforeDownload="beforeDownload($event)" ref="html2Pdf">

      <section slot="pdf-content"  style="padding: 40px 60px 60px 40px; ">

        <div class="table-responsive" id="pdfContrato" v-if="objeto.ecwl_aporte.numero_ccb" style="overflow-x: hidden;">
          <div class="row justify-content-between align-items-center" style="padding-right: 60px;" v-if="!isLoading">
            <div class="col-md-2 col align-self-start">
              <img :src="objeto.credor.logotipo_url" class="img-fluid">
            </div>
            <div class="col-md-auto col mt-2 text-center">
              <span :style="{letterSpacing: LETTER_SPACING}">{{ title }}</span> <br />Nº 
              <span :style="{letterSpacing: LETTER_SPACING}">
              {{ objeto.ecwl_aporte.numero_ccb }}
              </span>
            </div>
          </div>
          <div class="row justify-content-center" style="margin-bottom: 12px;">
            <b>
              Anexo I – Modelo de Cédula de Crédito Bancário e Termo de Endosso 
            </b>
          </div>
          <div class="row justify-content-center">
            <b>
              SOCINAL S.A. – CRÉDITO, FINANCIAMENTO E INVESTIMENTO
            </b>
          </div>
          <div class="row col-md-12">
            <b>1 - <span :style="{letterSpacing: LETTER_SPACING}">CREDORA</span></b>
            <br />
            <div class="table-border w-100">
              <div class="col col-md-12">
                <span :style="{letterSpacing: LETTER_SPACING}">
                A <b>{{ objeto.credor.razao_social }}</b>,
                </span>
                instituição financeira de direito privado,
                inscrita no CNPJ sob o nº {{ objeto.credor.cnpj }},
                com sede à <span :style="{letterSpacing: LETTER_SPACING}">{{ objeto.credor.endereco }},</span>
                do município de <span :style="{letterSpacing: LETTER_SPACING}">{{ objeto.credor.cidade }}</span> no Estado do {{ objeto.credor.uf }}.
              </div>
            </div>
          </div>

          <div class="row col-md-12 mt-2">
            <b>2 - <span :style="{letterSpacing: LETTER_SPACING}">EMITENTE - PESSOA JURIDICA</span></b>
            <div class="table-border w-100">
              <div class="row col-md-12">
                <div style="" class="col col-md-12">
                  <span class="title">
                    Nome:
                  </span>
                  <span :style="{letterSpacing: LETTER_SPACING}">
                    {{ objeto.ecwl_oferta.empresa_razao_social }}
                  </span>
                </div>
              </div>
              <div class="row col-md-12">
                <div style="" class="col col-md-4">
                  <span class="title">
                    CNPJ:
                  </span>
                  {{ objeto.ecwl_oferta.empresa_cnpj }}
                </div>
                <div style="" class="col col-md-4">
                  <span class="title">
                    IE:
                  </span>
                  {{ objeto.ecwl_oferta.empresa_ie }}
                </div>
                <div style="" class="col col-md-4">
                  <span class="title">
                    Data da Fundação:
                  </span>
                  <span :style="{letterSpacing: LETTER_SPACING}">
                    {{ objeto.ecwl_oferta.empresa_data_constituicao }}
                  </span>
                  <!-- {{ objeto.ecwl_oferta.empresa_data_constituicao.split('/')[0] }} / {{ objeto.ecwl_oferta.empresa_data_constituicao.split('/')[1] }} / {{ objeto.ecwl_oferta.empresa_data_constituicao.split('/')[2] }} -->
                </div>
              </div>
              <div class="row col-md-12">
                <div style="" class="col col-md-12">
                  <span class="title">
                    Endereço:
                  </span>
                  <span :style="{letterSpacing: LETTER_SPACING}"> 
                  {{ objeto.ecwl_oferta.empresa_rua }}
                  </span>
                </div>
              </div>
              <div class="row col-md-12">
                <div style="" class="col col-md-4">
                  <span class="title">
                    Cidade:
                  </span>
                  {{ objeto.ecwl_oferta.empresa_cidade }}
                </div>
                <div style="" class="col col-md-4">
                  <span class="title">
                    UF:
                  </span>
                  {{ objeto.ecwl_oferta.empresa_uf }}
                </div>
                <div :style="{letterSpacing: LETTER_SPACING}" class="col col-md-4">
                  <span class="title">
                    CEP:
                  </span>
                  <span :style="{letterSpacing: LETTER_SPACING}">
                    {{ objeto.ecwl_oferta.empresa_cep }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="row col-md-12 mt-2">
            <b>3 - GARANTIA (S) - PESSSOAL (IS) E OUTRAS</b>
            <div class="table-border w-100">
              <div class="row col-md-12">
                <div class="col col-md-8">
                  Avalista: <span :style="{letterSpacing: LETTER_SPACING}">{{ objeto.ecwl_oferta.avalistaPrincipal.nome || '' }}</span>
                </div>
                <div class="col col-md-4">
                  CNPJ: {{ objeto.ecwl_oferta.avalistaPrincipal.id.toString().replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,'$1.$2.$3/$4-$5') || '' }}
                </div>
              </div>
              <div class="row col-md-12">
                <div class="col col-md-3">
                  Cidade: <span :style="{letterSpacing: LETTER_SPACING}">{{ objeto.ecwl_oferta.avalistaPrincipal.endereco.cidade || '' }}</span>
                </div>
                <div class="col col-md-3">
                  Bairro: <span :style="{letterSpacing: LETTER_SPACING}">{{ objeto.ecwl_oferta.avalistaPrincipal.endereco.bairro || '' }}</span>
                </div>
                <div class="col col-md-3">
                  UF: <span :style="{letterSpacing: LETTER_SPACING}">{{ objeto.ecwl_oferta.avalistaPrincipal.endereco.estado || '' }}</span>
                </div>
                <div class="col col-md-3">
                  CEP: {{ objeto.ecwl_oferta.avalistaPrincipal.endereco.cep || '' }}
                </div>
                <br />
                <br />
              </div>
            </div>
          </div>

          <div class="row col-md-12 mt-2">
            <div class="table-border w-100">
              <div class="row col-md-12">
                <div class="col col-md-8">
                  Coobrigado (se houver):
                </div>
                <div class="col col-md-4">
                  CPF:
                </div>
              </div>
              <div class="row col-md-12">
                <div class="col col-md-3">
                  RG:
                </div>
                <div class="col col-md-3">
                  Órgão Emissor:
                </div>
                <div class="col col-md-3">
                  Naturalidade:
                </div>
                <div class="col col-md-3">
                  Nacionalidade:
                </div>
              </div>
              <div class="row col-md-12">
                <div class="col col-md-8">
                  Data Nascimneto:
                </div>
                <div class="col col-md-4">
                  Estado Civil:
                </div>
              </div>
              <div class="row col-md-12">
                <div class="col col-md-8">
                  Endereço:
                </div>
                <div class="col col-md-4">
                  CEP:
                </div>
              </div>
            </div>
          </div>

          <div class="row col-md-12 mt-2">
            <b>
              4 – CARACTERÍSTICAS DO CRÉDITO E CONDIÇÕES DE PAGAMENTO
            </b>
            <div class="table-border w-100" style="">
              <div class="row col-md-12">
                <div class="col col-md-12">
                  4.1 - Data do empréstimo/financiamento: {{ objeto.ecwl_oferta.data_encerramento }}
                  <br />

                  4.2 - Modalidade do Crédito: <span :style="{letterSpacing: LETTER_SPACING}">FINANCIAMENTO IMOBILIÁRIO</span> para fins exclusivo de moradia <br /> no Empreendimento a ser
                  desenvolvido pela Emitente sob o registro de incorporação nº {{ objeto.ecwl_oferta.ofertaNumeroRI }}, matrícula nº
                  {{ objeto.ecwl_oferta.ofertaNumeroMatricula }} registrada no cartório de registro de imóveis
                  nº {{ objeto.ecwl_oferta.ofertaNumeroCartorio }} da cidade de
                  {{ objeto.ecwl_oferta.cidade }} / {{ objeto.ecwl_oferta.uf }}. (doravante denominado “Empreendimento”)

                  <br />
                  4.3 - Praça de Pagamento: {{ objeto.credor.praca_pagamento }}
                  <br />
                  4.4 - Valor do crédito: {{ objeto.ecwl_aporte.valor | currency }}
                  <br />
                  4.5 - Valor do IOF: {{ objeto.simulacao.iof_nf | currency }}
                  <br />
                  4.6 - Valor da TC: {{ objeto.ecwl_oferta.valor_tarifa | currency }}
                  <br />
                  4.7 - Valor total do empréstimo/financiamento: {{ objeto.ecwl_aporte.valor | currency }}
                  <br />
                  4.8 - Valor líquido creditado: {{ objeto.simulacao.valor_liberado_nf | currency }}
                  <br />
                  4.9 - Quantidade de parcelas: {{ objeto.simulacao.parcelas.numero_parcelas  }}
                  <br />
                  4.10 - Valor das parcelas pré-fixadas: 
                  <span v-if="objeto.parcela_irregular">
                      {{ objeto.simulacao.parcelas.totalParcelas | currency }}
                  </span>
                  <span v-else>
                      {{ objeto.simulacao.parcelas.lista[0].valor_parcelas | currency }}
                  </span>
                  <br />
                  4.11 - Vencimento da primeira parcela: 
                  <span v-if="objeto.parcela_irregular">
                      {{ objeto.simulacao.parcelas.lista[0].data_pagamento }}
                  </span>
                  <span v-else>
                      {{ objeto.simulacao.parcelas.data_final_vencimento }}
                  </span>
                  <br />
                  4.12 - Vencimento da última parcela: 
                  <span v-if="objeto.parcela_irregular">
                    {{ objeto.simulacao.parcelas.lista[(objeto.simulacao.parcelas.lista.length)-1].data_pagamento }}
                  </span>
                  <span v-else>
                    {{ objeto.simulacao.parcelas.data_final_vencimento }}
                  </span>
                  <br />
                  4.13  - Taxa prefixada de juros a.m (%): {{ objeto.ecwl_oferta.taxa_juros }} + Taxa Pós-Fixada calculada
                  confirme Cláusula Terceira
                  <br />
                  4.14 - Taxa prefixada de juros a.a. (%): {{ objeto.simulacao.taxa_juros_anual }} + Taxa Pós-Fixada
                  calculada conforme Cláusula Terceira
                  <br />
                  4.15 - Taxa prefixada de juros a.m. - CET (%): {{ objeto.simulacao.cet_nf_mensal }} % + Taxa
                  Pós-Fixada calculada conforme Cláusula Terceira
                  <br />
                  4.16 - Taxa prefixada de juros a.a. - CET (%): {{ objeto.simulacao.cet_nf }} % + Taxa
                  Pós-Fixada calculada conforme Cláusula Terceira
                </div>
              </div>
            </div>
          </div>

        
          <div class="row col-md-12 mt-2">
            <b>5 - DADOS BANCÁRIOS PARA CRÉDITO</b>
            <div class="table-border w-100">
              <div class="row col-md-12">
                <div class="col col-md-3">
                  Nº do banco: {{ objeto.ecwl_oferta.numero_banco }}
                </div>
                <div class="col col-md-3">
                  Nº da agência: {{ objeto.ecwl_oferta.agencia }}
                </div>
                <div class="col col-md-3">
                  Nº da conta: {{ objeto.ecwl_oferta.conta }} - {{ objeto.ecwl_oferta.digito_conta }}
                </div>
                <div class="col col-md-3">
                  Tipo de conta: Conta Corrente
                </div>
              </div>
              <div class="row col-md-12">
                <div class="col col-md-6" style="">
                  Favorecido: <span :style="{letterSpacing: LETTER_SPACING}">{{ objeto.ecwl_oferta.empresa_razao_social }}</span>
                </div>
                <div class="col col-md-6">
                  CNPJ: {{ objeto.ecwl_oferta.empresa_cnpj }}
                </div>
              </div>
            </div>
          </div>

          <div class="row col-md-12 mt-2">
            <span style=""><b>6 - FLUXO DE PAGAMENTO DAS PARCELAS</b></span>
            <div class="table-border w-100">
              <div class="row col-md-12" v-for="parcela in objeto.simulacao.parcelas.lista"
                :key="parcela.numero_prestacao">
                <div class="col col-md-2">
                  Parcela
                </div>
                <div class="col col-md-2">
                  {{ parcela.numero_prestacao }}
                </div>
                <div class="col col-md-4">
                  Vencimento {{ parcela.data_pagamento }}
                </div>
                <div class="col col-md-4">
                  Valor {{ parcela.valor_parcelas | currency }}
                </div>
              </div>
            </div>
          </div>


          <div class="row w-100 mt-4">
            <div class="col col-md-12">
              <div style="">
                Na forma das cláusulas a seguir, por esta <span :style="{letterSpacing: LETTER_SPACING}">CÉDULA DE CRÉDITO BANCÁRIO</span>,
                doravante <span :style="{letterSpacing: LETTER_SPACING}">CÉDULA</span> , emitida em conformidade com a Lei nº 10.931,
                de 02/08/2004, pagarei à <span :style="{letterSpacing: LETTER_SPACING}">CREDORA</span> ou à sua ordem, nas datas designadas
                no item 6 do preâmbulo, a quantia
              <div>constante no subitem 4.7, acrescida
                dos encargos estipulados no subitem 4.15, em dinheiro, quantia esta certa, líquida e exigível,
                decorrente de operação de crédito. O valor do crédito (subitem 4.4 do preâmbulo) representado por esta
                <span :style="{letterSpacing: LETTER_SPACING}">CÉDULA</span> ,
                será liberado pela <span :style="{letterSpacing: LETTER_SPACING}">CREDORA</span> , deduzidos dos custos dos subitens 4.5 e 4.6, quando for o caso, assim como
                possível (eis)
                saldo (s) devedor (es) em nome do <span :style="{letterSpacing: LETTER_SPACING}">EMITENTE</span> , conforme valor definido no subitem 4.8, em conta corrente do
                <span :style="{letterSpacing: LETTER_SPACING}">EMITENTE</span> ou a sua ordem, ou, caso não tenha conta corrente, mediante cheque nominal ao <span :style="{letterSpacing: LETTER_SPACING}">EMITENTE</span> ou ordem de
                pagamento
                ou outra forma 
                <p>
                  prevista na legislação; no caso de financiamento de bens  e / ou serviços, mediante depósito em conta corrente
                  do vendedor/fornecedor do bem ou do prestador de serviços.
                </p>
              </div>
              </div>

              <div style="">
                <b>PRIMEIRA</b> – Em garantia do integral cumprimento de todas as obrigações estabelecidas nesta cédula,
                o <span :style="{letterSpacing: LETTER_SPACING}">EMITENTE</span> dá a <span :style="{letterSpacing: LETTER_SPACING}">CREDORA</span> as garantias mencionadas no item 3 do preâmbulo.
              </div>

              <div style="">
                <b>SEGUNDA</b> – O(s) <span :style="{letterSpacing: LETTER_SPACING}">AVALISTA (S)</span>  e / ou COOBRIGADO (S), nomeados no item 3 do preâmbulo desta <span :style="{letterSpacing: LETTER_SPACING}">CÉDULA</span> ,
                declaram-se)
                solidariamente responsável(eis) com o <span :style="{letterSpacing: LETTER_SPACING}">EMITENTE</span> pelo cumprimento de todas as obrigações, principais e
                acessórias, resultantes dessa <span :style="{letterSpacing: LETTER_SPACING}">CÉDULA</span> , nos termos do art. 264, 265 e 275da Lei nº 10.406, de 10 de janeiro
                de
                2002, conforme alterada (“Código Civil”).
              </div>

              <!--CLAUSULA TERCEIRA | QUARTA | QUINTA |  são diferentes entre Bullet e Juros simples| SEXTA só Bullet -->
              <span v-if="objeto.parcela_irregular">
                <div style="">
                  <b>TERCEIRA</b> – O  <span :style="{letterSpacing: LETTER_SPACING}">EMITENTE</span>   e / ou <span :style="{letterSpacing: LETTER_SPACING}">AVALISTA (S)</span> por este instrumento, constituem-se mutuamente procuradores, com recíprocos e especiais poderes irrevogáveis, e irretratáveis, 
                  para receber cobranças extrajudiciais e citação inicial, em caso de eventual ação oriunda desta <span :style="{letterSpacing: LETTER_SPACING}">CÉDULA</span> , podendo, ainda, receber intimação de penhora, 
                  bem como de todos e quaisquer atos processuais que se tornem necessários para o normal andamento dos processos judiciais ou extrajudiciais.
                </div>
                <div style="">
                  <b>QUARTA</b> – O  <span :style="{letterSpacing: LETTER_SPACING}">EMITENTE</span>  e <span :style="{letterSpacing: LETTER_SPACING}">AVALISTA (S)</span> declaram expressamente que: (i) ficaram cientes, nesta data, dos fluxos considerados no cálculo do CET – Custo 
                  Efetivo Total e de que a taxa percentual indicada no item <span :style="{letterSpacing: LETTER_SPACING}">4.15 do </span> preâmbulo representa as condições vigentes na data do cálculo; (ii) 
                  contrataram essa operação de forma consciente, evitando seu excessivo endividamento (iii) são verdadeiras todas as informações por eles prestadas e 
                  informarão à <span :style="{letterSpacing: LETTER_SPACING}">CREDORA</span> , no prazo máximo de 10 (dez) dias, sempre que houver qualquer alteração em seus dados cadastrais; (iv) não utilizarão os recursos 
                  tomados junto à <span :style="{letterSpacing: LETTER_SPACING}">CREDORA</span> para o desempenho de atividades prejudiciais ao Meio Ambiente ou de exploração de trabalho forçado ou infantil, e; (v) 
                  informarão a <span :style="{letterSpacing: LETTER_SPACING}">CREDORA</span>caso sejam ou venham a se tornar <span :style="{letterSpacing: LETTER_SPACING}">PESSOA POLITICAMENTE EXPOSTA</span>, nos termos do art. 4 da Circular n.º 3.461/09 do Banco Central do Brasil, conforme alterada.
                </div>
                <div style="">
                  <b>QUINTA</b> – A <span :style="{letterSpacing: LETTER_SPACING}">CREDORA</span>  a qualquer tempo, de modo a garantir a estabilidade contratual, e ainda na hipótese desta CÉDULA ser endossada à terceiros, o novo credor, poderá exigir do EMITENTE garantia complementar, especialmente alienação fiduciária de participação societária em pessoa 
                  jurídica com lastro financeiro suficiente, que será organizada por instrumento complementar, devidamente registrada na junta comercial do estado competente e anexa a esta CÉDULA
                </div>
              </span>
              <span v-else>
                <p>
                  <b>TERCEIRA</b> – A Parcela Variável descrita no quadro 4 será calculada de acordo com a seguinte fórmula
                  de
                  cálculo: Os termos desta fórmula serão entendidos conforme designados abaixo:
                </p>


                <div class="row col-md-12 justify-content-center">
                  <img src="../../assets/images/formula_parcela_variavel.png" alt="Fórmula Parcela Variável"
                    style="width: 100%; max-width: 540px;" />
                </div>

                <p>
                  Os termos desta fórmula serão entendidos conforme designados abaixo:
                </p>

                <p>
                  <b>Parcela Variável:</b> Valor que deverá ser pago para quitação desta cédula na última parcela conforme
                  item 6
                  do preâmbulo
                </p>

                <p>
                  <b>VGV:</b> Valor geral de vendas do Empreendimento descrito no item 4.2, atualizado pela variação
                  positiva do INCC-M (fonte a ser utilizada será a FGV), ou outro que venha a substitui-lo, do período entre
                  o item 4.1 e cinco dias úteis antes da data descrita no item 4.12.
                </p>

                <p>
                  <b>Somatório das parcelas já pagas:</b> a soma do valor nominal das parcelas descritas no quadro número 6,
                  sem nenhum tipo de correção e não contabilizando quaisquer multas ou encargos pagos durante o período
                  deste título.
                </p>

                <p>
                  <b> M² Privativos Totais:</b> O somatório da metragem quadrada privativa de cada uma das unidades do
                  Empreendimento conforme matrícula indicada no item 4.2 do preâmbulo, descontadas as unidades alvo de
                  permuta física.
                </p>

                <p>
                  <b>M² Privativos Não Comercializados: </b> Os M² Privativos Totais que não tiverem nenhum contrato de
                  venda ou promessa de compra e venda
                  assinados até cinco dias úteis antes da data descrita no item <span :style="{letterSpacing: LETTER_SPACING}">4.12 do </span> preâmbulo.
                </p>

                <p>
                  <b>Valor do Financiamento:</b> Valor descrito no item 4.4.
                </p>

                <p>
                  <b>CDI do Período:</b> 100% do CDI acumulado (fonte será o Banco Central do Brasil), ou outro índice que
                  venha a substitui-lo, do período entre o item 4.1 e cinco dias úteis antes da data descrita no ite<span :style="{letterSpacing: LETTER_SPACING}">4.12 do </span> preâmbulo.
                </p>

                <p>
                  Parágrafo Primeiro – Caso a parcela variável resulte em um valor negativo ela deverá, para todos os
                  efeitos, ser considerada R$0,00.
                </p>

                <p>
                  Parágrafo Segundo – A Emitente, ao assinar esta cédula, garante que: (i) é empresa do ramo da construção
                  civil e portanto tem pleno conhecimento e familiaridade com todos os parâmetros de cálculo utilizado; (ii)
                  tem condições de, permanentemente, averiguar o valor de cada um dos parâmetros e assim, calcular o seu
                  saldo devedor; (iii) é capaz de realizar projeções de cenários pessimistas, realistas e otimistas, entendo
                  todas as possíveis consequências de tomar um financiamento cujo valor tem base no cálculo acima
                </p>
                <p>
                  <b>QUARTA</b> – O <span :style="{letterSpacing: LETTER_SPACING}">EMITENTE</span>  e / ou <span :style="{letterSpacing: LETTER_SPACING}">AVALISTA (S)</span> por este instrumento, constituem-se mutuamente procuradores,
                  com recíprocos e especiais poderes irrevogáveis, e irretratáveis, para receber cobranças extrajudiciais e
                  citação inicial, em caso de eventual ação oriunda desta <span :style="{letterSpacing: LETTER_SPACING}">CÉDULA</span> , podendo, ainda, receber intimação de
                  penhora, bem como de todos e quaisquer atos processuais que se tornem necessários para o normal andamento
                  dos processos judiciais ou extrajudiciais
                </p>
                <p>
                  <b>QUINTA</b> – O <span :style="{letterSpacing: LETTER_SPACING}">EMITENTE</span> e <span :style="{letterSpacing: LETTER_SPACING}">AVALISTA (S)</span> declaram expressamente que: (i) ficaram cientes, nesta data, dos
                  fluxos considerados no cálculo do CET – Custo Efetivo Total e de que a taxa percentual indicada no item
                  4.15 do preâmbulo representa as condições vigentes na data do cálculo; (ii) contrataram essa operação de
                  forma consciente, evitando seu excessivo endividamento (iii)são verdadeiras todas as informações por eles
                  prestadas e informarão à <span :style="{letterSpacing: LETTER_SPACING}">CREDORA</span> , no prazo máximo de 10 (dez) dias, sempre que houver qualquer alteração
                  em seus dados cadastrais; (iv)não utilizarão os recursos tomados junto à <span :style="{letterSpacing: LETTER_SPACING}">CREDORA</span> para o desempenho de
                  atividades prejudiciais ao Meio Ambiente ou de exploração de trabalho forçado ou infantil, e; (v)
                  informarão a <span :style="{letterSpacing: LETTER_SPACING}">CREDORA</span> caso sejam ou venham a se tornar PESSOA POLITICAMENTE EXPOSTA, nos termos do art. 4
                  da Circular n.º 3.461/09 do Banco Central do Brasil, conforme alterada.
                </p>
              </span>
              <!--FIM CLAUSULA TERCEIRA | QUARTA | QUINTA só Bullet-->
              
              <div style="">
                  <b>SEXTA</b> – É assegurada ao <span :style="{letterSpacing: LETTER_SPACING}">EMITENTE</span>   a liquidação antecipada desta <span :style="{letterSpacing: LETTER_SPACING}">CÉDULA</span> , mediante redução proporcional dos juros, encargos e demais acréscimos 
                  incidentes sobre o saldo devedor. Neste caso, o valor presente dos pagamentos previstos para fins de liquidação antecipada será calculado mediante 
                  utilização da taxa de juros pactuada.
                </div>
              <div>
                <b>SÉTIMA</b>
                    – A <span :style="{letterSpacing: LETTER_SPACING}">CREDORA</span> poderá considerar a dívida e os acessórios objetos desta <span :style="{letterSpacing: LETTER_SPACING}">CÉDULA</span> vencidos por
                    antecipação, independente de aviso, interpelação ou notificação judicial ou extrajudicial, tornando-se
                    imediatamente exigíveis, nas hipóteses previstas nos art. 333 e 1.425 do Código Civil, ou em quaisquer dos
                    seguintes casos, se:
                <br />
              </div>
              <ol class="alfaParen" style="padding-left: 40px;">
                <li style="">
                  O <span :style="{letterSpacing: LETTER_SPACING}">EMITENTE</span>  e / ou seu (s) <span :style="{letterSpacing: LETTER_SPACING}">AVALISTA (S)</span> incorrerem em processo de insolvência civil,
                  entrarem em processo de liquidação extrajudicial, tiverem sua falência decretada ou requererem
                  recuperação
                  judicial, dissolução amigável ou judicial e protesto de títulos,
                </li>
                <li style="">
                  Caso o controle societário do <span :style="{letterSpacing: LETTER_SPACING}">EMITENTE</span>
                  seja transferido direta ou indiretamente a terceiro sem consentimento, por escrito, da <span :style="{letterSpacing: LETTER_SPACING}">CREDORA</span>;
                </li>
                <li style="">
                  Contra
                  o <span :style="{letterSpacing: LETTER_SPACING}">EMITENTE</span>  e / ou seu (s) <span :style="{letterSpacing: LETTER_SPACING}">AVALISTA (S)</span> for movida qualquer ação ou execução que afete as garantias
                  previstas
                  nesta <span :style="{letterSpacing: LETTER_SPACING}">CÉDULA</span>;

                </li>

                <li style="">
                  O <span :style="{letterSpacing: LETTER_SPACING}">EMITENTE</span> transferir a terceiros, por qualquer forma, os direitos e obrigações que adquiriu e
                  assumiu
                  nesta <span :style="{letterSpacing: LETTER_SPACING}">CÉDULA</span> , sem consentimento prévio, por escrito, da <span :style="{letterSpacing: LETTER_SPACING}">CREDORA</span>;

                </li>
                <li style="">
                  Não forem verdadeiras as informações
                  prestadas para obtenção do empréstimo/financiamento junto à <span :style="{letterSpacing: LETTER_SPACING}">CREDORA</span>;

                </li>
                <li style="">
                  O <span :style="{letterSpacing: LETTER_SPACING}">EMITENTE</span> ou seu (s) <span :style="{letterSpacing: LETTER_SPACING}">AVALISTA (S)</span>
                  deixar de cumprir quaisquer das obrigações pactuadas nesta <span :style="{letterSpacing: LETTER_SPACING}">CÉDULA</span> ou em quaisquer outras cédulas
                  emitidas
                  em favor da <span :style="{letterSpacing: LETTER_SPACING}">CREDORA</span> , incluindo, mas não se limitando, as obrigações de pagamento nas respectivas
                  datas.

                </li>
                <li style="">

                  caso o Emitente ou o Avalista tenham título levado a protesto  e / ou nome inserido em qualquer órgão de
                  proteção ao crédito, em valor igual ou superior a 30% (trinta por cento) do Valor de Principal  e / ou R$
                  5.000,00 (cinco mil reais), o que for menor, sem a devida regularização no prazo de 25 (vinte e cinco)
                  dias da data da sua ciência do fato;

                </li>
                <li style="">

                  caso o Emitente ou o Avalista sejam inscritos no Cadastro de
                  Emitente de Cheques sem Fundos (CCF) após a data de emissão desta Cédula, sem a devida regularização
                  no
                  prazo de 15 (quinze) dias a contar da sua ciência do fato.
                </li>
              </ol>
              <p>
                <b>OITAVA</b>
                 – O atraso no pagamento de quaisquer importâncias devidas, vencidas e não pagas na época em
                que
                forem exigíveis por força do disposto nesta Cédula, ou nas hipóteses de vencimento antecipado da dívida
                adiante previstas, implicará, automaticamente, na mora, ficando o débito sujeito, desde o vencimento até o
                efetivo pagamento, a:
              </p>

              <ol class="alfaParen" style="padding-left: 40px;">
                <li>
                  juros remuneratórios às taxas indicadas nos itens 4.13  e 4.14, ou à taxa média de mercado vigente na
                  data do efetivo pagamento estipulada pelo Banco Central para as operações da mesma modalidade,
                  prevalecendo a que resultar em maior valor, aplicáveis sobre o capital devidamente corrigido pelo IGP -M;
                </li>
                <li>
                  juros moratórios de 1 % a.m. (um por cento ao mês) ou fração (pro rata temporis); e
                </li>
                <li>
                  multa de 10 % (dez por cento) sobre o total do débito não pago, incluindo encargos moratórios e
                  remuneratórios.
                </li>
              </ol>

              <div style="">
                Parágrafo Primeiro – Além dos encargos mencionados nesta Cláusula Quarta, acima, o <span :style="{letterSpacing: LETTER_SPACING}">EMITENTE</span> e
                o (s)  <span :style="{letterSpacing: LETTER_SPACING}">AVALISTA (S)</span>, neste ato, obrigam-se, em caráter irrevogável e irretratável, na hipótese de
                inadimplemento, ao pagamento ou, conforme aplicável, reembolso: (i) em fase extrajudicial, das despesas
                relacionadas às medidas de cobrança e dos respectivos honorários advocatícios, estes, todavia, limitados
                ao equivalente a 10 % (dez por cento) do valor total à época devido; e (ii) em fase judicial, das custas e
                despesas decorrentes do processo, bem como dos honorários advocatícios contratuais e arbitrados pelo
                juízo.
              </div>

              <div class="html2pdf__page-break" />

               <div style="">
                Parágrafo Segundo – Configuração da Mora – Para efeitos desta CCB, configurar-se-á a mora do Emitente
                quando este não
                cumprir, no prazo e na forma devidos, qualquer obrigação de
                pagamento, seja de principal ou de encargos, ou quaisquer outras obrigações contraídas junto à <span :style="{letterSpacing: LETTER_SPACING}">CREDORA</span> em
                decorrência desta <span :style="{letterSpacing: LETTER_SPACING}">CÉDULA</span>. A
                configuração da mora independerá de qualquer aviso, notificação ou interpelação, resultando do simples
                inadimplemento das obrigações assumidas nesta Cédula.
              </div>

              <div style="">
                Parágrafo Terceiro – O Emitente e o Avalista declaram ter conhecimento de que, para qualquer amortização
                 e / ou liquidação, seja de principal  e / ou de juros, mediante débito em conta corrente ou entrega de recursos
                à <span :style="{letterSpacing: LETTER_SPACING}">CREDORA</span> , tais recursos deverão corresponder a recursos livres, de procedência lícita, desbloqueados,
                transferíveis e disponíveis em reservas bancárias, para comportar o débito ou crédito, nas datas dos
                vencimentos das obrigações assumidas. Assim, enquanto não estiver disponível a importância necessária para
                a liquidação pretendida, a <span :style="{letterSpacing: LETTER_SPACING}">CREDORA</span> cobrará pelos dias que decorrerem até a efetiva disponibilização dos
                recursos, os mesmos encargos ajustados nesta Cédula.
              </div>

              <p>
                <b>Parágrafo Quarto – </b> A quitação de parcela(s) posterior(es) não implica na quitação de parcela(s)
                anterior(es).
              </p>
              <p>
                <b>NONA</b>
                 – Todas as despesas decorrentes desta <span :style="{letterSpacing: LETTER_SPACING}">CÉDULA</span> , inclusive tarifas, impostos, registros, arquivos
                e formalização, serão pagos pelo <span :style="{letterSpacing: LETTER_SPACING}">EMITENTE</span>.
              </p>

              <div>
                 <div style="">
                <b>DÉCIMA</b>
                    – O <span :style="{letterSpacing: LETTER_SPACING}">EMITENTE</span>  e / ou o(s) <span :style="{letterSpacing: LETTER_SPACING}">AVALISTA (S)</span> autoriza(m) a <span :style="{letterSpacing: LETTER_SPACING}">CREDORA</span> , a qualquer tempo, para fins da Lei
                    Complementar nº 105, de 10 de janeiro de 2001, da Lei 12.965, de 23 de abril de 2014 (Marco Civil da
                    Internet) e demais leis e regulamentos aplicáveis, a: (i) compartilhar informações cadastrais e relativas
                    às suas operações com outras empresas e pessoas que contribuem para a análise cadastral, de crédito, o
                    processamento e a cobrança das obrigações pactuadas nesta <span :style="{letterSpacing: LETTER_SPACING}">CÉDULA</span>; (ii) fornecer ao Banco Central do
                    Brasil, para integrar o Sistema de Informações de Crédito (“SCR”), informações sobre o valor de suas
                    dívidas a vencer e vencidas; (iii) consultar suas informações no SCR, em cadastros positivos e negativos
                    de crédito; (iv) fornecer às autoridades governamentais competentes as informações solicitadas; (v)
                    verificar os dados constantes no cadastro e fornecer ao Banco Central do Brasil, ao Conselho de Controle
                    de Atividades Financeiras, à Comissão de Valores Mobiliários, à Receita Federal e aos gestores de
                    cadastros positivos e negativos informações relativas aos seus dados cadastrais, saldos e movimentações
                    financeiras; (vi) fornecer todas as informações necessárias para o registro desta <span :style="{letterSpacing: LETTER_SPACING}">CÉDULA</span>  e / ou de suas
                    garantias em cartórios, câmaras de custódia ou centrais de registro, e; (vii) fornecer, à eventual
                    cessionário ou endossatário desta <span :style="{letterSpacing: LETTER_SPACING}">CÉDULA</span> , todos os dados e documentos relativos ao cadastro e ao crédito
                 </div>
              </div>

              <div>
                 <div style="">
                <b>DÉCIMA PRIMEIRA</b>
                  – A <span :style="{letterSpacing: LETTER_SPACING}">CREDORA</span> poderá ceder ou transferir, no todo ou em parte, os direitos, obrigações e garantias da
                  presente <span :style="{letterSpacing: LETTER_SPACING}">CÉDULA</span> (via “NEGOCIÁVEL”), sem necessidade de comunicação prévia ao <span :style="{letterSpacing: LETTER_SPACING}">EMITENTE</span>. Eventual
                  cessionário ou endossatário desta <span :style="{letterSpacing: LETTER_SPACING}">CÉDULA</span> , mesmo não sendo instituição financeira, poderá exercer todos os
                  direitos por ela conferidos, inclusive cobrar os juros e demais encargos aqui pactuados, se tornando, tal
                  cessionário ou endossatário, responsável pela cobrança e atendimento ao <span :style="{letterSpacing: LETTER_SPACING}">EMITENTE</span>.
                 </div>
              </div>

              <div>
                 <div style="">
                <b>DÉCIMA SEGUNDA</b>
                  – O <span :style="{letterSpacing: LETTER_SPACING}">EMITENTE</span> autoriza o tratamento (coleta, produção, recepção, classificação,
                  utilização, acesso, reprodução, transmissão, distribuição, processamento, arquivamento, armazenamento,
                  eliminação, avaliação ou controle da informação, modificação, comunicação, transferência, difusão ou
                  extração) dos seus dados mantidos pela <span :style="{letterSpacing: LETTER_SPACING}">CREDORA</span> ou seu sucessor em vista da contratação da operação de
                  crédito representada por esta <span :style="{letterSpacing: LETTER_SPACING}">CÉDULA</span> , para as finalidades previstas em lei. A <span :style="{letterSpacing: LETTER_SPACING}">CREDORA</span> , ou seu sucessor,
                  atuando como controlador dos dados nesse contexto, e valendo-se de seus legítimos interesses, fica
                  autorizada a utilizar os dados, cruzá-los  e / ou enriquecê-los com outros dados para a criação de perfis
                  demográficos, de crédito e socioeconômicos de pessoas físicas e jurídicas; levantamento de informações
                  estatísticas e de mercado, como substrato para a criação ou para a análise do sucesso de anúncios, on-line
                  ou off-line, próprios ou de seus parceiros comerciais; melhoria dos produtos e algoritmos da <span :style="{letterSpacing: LETTER_SPACING}">CREDORA</span> , ou
                  seu sucessor, ou de seus parceiros comerciais; assim como para a preparação de relatórios, métricas e
                  outras soluções e softwares de inteligência de negócios voltadas a si própria ou a seus parceiros
                  comerciais. Ademais, os dados podem ser utilizados, de forma limitada, em ambiente controlado, sem uso
                  comercial primário, para fins de testes de conceitos (ProofofConcept - POC), visando a criação de novos
                  serviços, produtos, funcionalidades e eficácia de algoritmos; assim como para permitir, por meio de
                  compartilhamento aos seus parceiros comerciais, o direcionamento de anúncios aos titulares dos dados e a
                  terceiros.
                 </div>
              </div>

              <div style="">
                <b>Parágrafo Único</b> –O <span :style="{letterSpacing: LETTER_SPACING}">EMITENTE</span> reconhece que a <span :style="{letterSpacing: LETTER_SPACING}">CREDORA</span> , ou seu sucessor, poderá tratar os seus dados
                nos
                termos dessa cláusula, inclusive cruzando-os com outros dados que detenha ou que venha a deter em seus
                servidores. A <span :style="{letterSpacing: LETTER_SPACING}">CREDORA</span> , ou seu sucessor, garante que todo e qualquer tratamento dos dados coletados será
                realizado exclusivamente para atingir as finalidades relacionadas ao objeto desta <span :style="{letterSpacing: LETTER_SPACING}">CÉDULA</span>.
              </div>

              <div class="html2pdf__page-break" />

              <div style="">
                <b>DÉCIMA TERCEIRA</b>
                 – A presente <span :style="{letterSpacing: LETTER_SPACING}">CÉDULA</span> é um título executivo extrajudicial, emitida de forma
                eletrônica em vias
                de conteúdo idêntico para as Partes envolvidas.
              </div>

              <div style="">
                <b>DÉCIMA QUARTA</b>
                 – A presente <span :style="{letterSpacing: LETTER_SPACING}">CÉDULA</span> é emitida em caráter
                irrevogável e irretratável, e obriga todos os seus signatários e seus eventuais sucessores a qualquer
                título.
              </div>

              <div style="">
                <b>DÉCIMA QUINTA</b>
                 – Caso alguma disposição desta <span :style="{letterSpacing: LETTER_SPACING}">CÉDULA</span> venha a ser considerada ilegal, inexequível ou
                nula, as demais disposições permanecerão válidas. Qualquer tolerância da <span :style="{letterSpacing: LETTER_SPACING}">CREDORA</span> em relação às obrigações
                assumidas nesta <span :style="{letterSpacing: LETTER_SPACING}">CÉDULA</span> será considerada mera liberalidade, não gerando direitos ao <span :style="{letterSpacing: LETTER_SPACING}">EMITENTE</span> nem podendo
                ser
                interpretada como renúncia, novação ou aditamento, podendo o cumprimento das obrigações ser exigido a
                qualquer tempo.
              </div>

              <div style="">
                <b>DÉCIMA SEXTA</b>
                 – Caso esta <span :style="{letterSpacing: LETTER_SPACING}">CÉDULA</span> seja contratada pelo <span :style="{letterSpacing: LETTER_SPACING}">EMITENTE</span> através de meios eletrônicos
                disponibilizados pela <span :style="{letterSpacing: LETTER_SPACING}">CREDORA</span> ou por terceiros por ela contratados (via aplicativos ou sites), o <span :style="{letterSpacing: LETTER_SPACING}">EMITENTE</span>
                reconhece que este meio de contratação é válido, bem como todas suas etapas e que sua identificação no
                momento da contratação, composta por seu nome de usuário e senha ou qualquer outro dispositivo de
                segurança que lhe tenha sido apresentado são provas de sua concordância com este formato de contratação,
                mesmo que não haja utilização de certificado digital ICP-BRASIL. Qualquer discordância relacionada a esta
                forma de contratação deverá ser acompanhada de prova, nos termos do artigo 10, parágrafo segundo da Medida
                Provisória nº. 2.200-2/2001 e do artigo 225 do Código Civil.
              </div>

              <div style="">
                Fica eleito o Foro da comarca de São Paulo (SP), para dirimir todas as dúvidas ou controvérsias oriundas
                deste instrumento, com renúncia de qualquer outro. Estando assim convencionadas e pactuadas, firmam as
                Partes o presente instrumento, sendo esta <span :style="{letterSpacing: LETTER_SPACING}">CÉDULA</span> emitida em vias de igual teor e forma, conforme cláusula
                <span :style="{letterSpacing: LETTER_SPACING}">DÉCIMA PRIMEIRA</span>, na presença dos avalistas abaixo, se houver.
              </div>

            </div>
          </div>

          <div class="row" style="text-align: center; margin-top: 24px;">
            <br />
            <br />

            <div class="col-md-5">
              <hr>
              Local e data: {{ objeto.credor.praca_pagamento }}, {{ objeto.ecwl_aporte.data }}<br>
            </div>
            <div class="col-md-5">
              <hr>
              <span :style="{letterSpacing: LETTER_SPACING}">EMITENTE: {{ objeto.ecwl_oferta.empresa_razao_social }}</span><br>
              <!-- CPF/CNPJ: {{ objeto.ecwl_oferta.empresa_cnpj }} -->
            </div>


            <div class="col-md-2"></div>

            <div class="col-md-5">
            </div>
            <div class="col-md-5">
              <br>
              <b>DECLARAÇÃO</b><br>
              <span style="font-size: 14px;">
                Li previamente esta Cédula e não tenho dúvidas sobre quaisquer de suas cláusulas.
              </span>
            </div>
          </div>

          <br><br>

          <div class="row" style="font-size: 14px;">
            <div class="col-md-5">
              <hr>
              <span :style="{letterSpacing: LETTER_SPACING}">AVALISTA 1: {{ objeto.ecwl_oferta.avalistaPrincipal.nome || '' }} </span> <br />
              CNPJ: {{ objeto.ecwl_oferta.avalistaPrincipal.id.toString().replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,'$1.$2.$3/$4-$5') || '' }}
            </div>
            <div class="col-md-5" v-if="!objeto.parcela_irregular && (!objeto.ecwl_oferta.demaisAvalistas || objeto.ecwl_oferta.demaisAvalistas.length === 0)">
              <hr>
              <span :style="{letterSpacing: LETTER_SPACING}">AVALISTA</span> 2: <br />
              CPF:
            </div>
          </div>
          <br />
          <span v-if="!objeto.parcela_irregular"> 
            <div class="row" style="font-size: 14px;">
              <div class="col-md-5">
                <hr>
                 Cônjuge: <br />
                 CPF:
              </div>
            <div class="col-md-5">
              <hr>
                Cônjuge: <br />
               CPF:
            </div>
            </div>
          </span>
          <br />
          <br />

          <span v-if="!objeto.parcela_irregular">
            <div class="row col-md-12">
              <div class="col col-md-5 table-border">
               Eu, <b>Avalista 1</b>, declaro, quanto ao meu estado civil, que sou: <br />casado com comunhão de bens( ); casado
               sem comunhão de bens( ); solteiro( ); divorciado( ); separado( ); viúvo( ), nos termos do novo Código Civil
               Brasileiro.
              </div>
              <div class="col-md-2"> </div>
              <div class="col col-md-5 table-border">
               Eu, <b>Avalista 2</b>, declaro, quanto ao meu estado civil, que sou: <br /> casado com comunhão de bens( ); casado
               sem comunhão de bens( ); solteiro( ); divorciado( ); separado( ); viúvo( ), nos termos do novo Código Civil
                Brasileiro.
             </div>
            </div>
          </span>
          
          <br />
          <br />
          <div class="html2pdf__page-break" />
          <!--ADD_PAGE-->
          <div>

            <div class="row col-md-12 justify-content-center" style="text-align: center; " id="termoEndosso">
              <b><span :style="{letterSpacing: LETTER_SPACING}">TERMO DE ENDOSSO DA CÉDULA DE CRÉDITO BANCÁRIO Nº</span> {{ objeto.ecwl_aporte.numero_ccb }} </b>
            </div>

            <br />
            <br />

            <div class="row col-md-12">
              <p>
                <b>
                  {{ objeto.ecwl_oferta.empresa_razao_social }}, neste ato devidamente representada, na forma de seus atos societários, doravante
                  designada simplesmente Emitente; e
                </b>
              </p>

              <p>
                <b><span :style="{letterSpacing: LETTER_SPACING}">SOCINAL S.A. – CRÉDITO, FINANCIAMENTO E INVESTIMENTO</span></b>, instituição financeira de direito privado,
                com
                sede na Avenida Brasil, nº 10, quarto andar, Centro, na Cidade de Araruama, Estado do Rio de Janeiro, CEP
                28970-000, inscrita no Cadastro Nacional da Pessoa Jurídica do Ministério da Economia (“<b>CNPJ</b>”) sob
                o
                nº
                03.881.423/0001-56, neste ato devidamente representada, na forma de seus atos societários, doravante
                designada simplesmente <b>Endossante</b>; e
              </p>

              <p>
                {{ objeto.ecwl_aporte.investidor_nome }}, inscrito no CPF sob o nº
                {{ objeto.ecwl_aporte.investidor_cpf }},
                residente à {{ objeto.ecwl_aporte.investidor_endereco }}, {{ objeto.ecwl_aporte.investidor_endereco_cidade
                }}/{{ objeto.ecwl_aporte.investidor_endereco_uf }}, doravante denominada
                simplesmente <b>Endossatária</b>;
              </p>

              <p>
                <b>Endossante, Endossatária e Emitente</b> são também individualmente denominadas uma <b>“Parte”</b> e, em
                conjunto, as <b>“Partes”</b>
              </p>

              <p>
                <b>
                  CONSIDERANDO QUE:
                </b>
              </p>

              <p>
                A. A <b>Emitente</b> e a Endossante celebraram a CCB nº <span :style="{letterSpacing: LETTER_SPACING}">{{ objeto.ecwl_aporte.numero_ccb }}</span>, doravante denominada simplesmente “CCB”;
                e
              </p>

              <p>
                B. As <b>Partes</b> desejam formalizar o efetivo endosso da CCB descrita neste instrumento pela
                <b>Endossante</b> à <b>Endossatária</b>;
              </p>


              <div style="">
                <span :style="{letterSpacing: LETTER_SPACING}">RESOLVEM</span> as <b>Partes</b> celebrar o presente <span style="font-style: italic;">Termo de Endosso de Cédula de
                  Crédito Bancário nº {{ objeto.ecwl_aporte.numero_ccb }} (“<b>Termo de Endosso</b>”)</span>,de acordo com
                as
                seguintes cláusulas e
                condições:
              </div>

              <ol style="padding-left: 30px;" class="nestedList">
                <li>Este Termo de Endosso tem por objeto o endosso em preto da CCB.</li>
                <li>
                  Em contraprestação ao endosso da CCB, a Endossatária deverá pagar à Endossante o valor total de {{
                    objeto.ecwl_aporte.valor | currency }}
                </li>
                <li>
                  Concordam as <b>Partes</b>, desde já, que o não pagamento do valor acima indicado tornará sem efeito o endosso
                  realizados pela <b>Endossante</b>, objeto deste Termo de Endosso
                </li>
                <li>
                  A <b>Endossatária</b> tem conhecimento de que a <b>Endossante</b> procedeu à análise cadastral e à
                  análise
                  de crédito e
                  risco necessária para a realização da operação de Crédito que resultou na emissão da CCB objeto deste
                  Termo de Endosso. Entretanto, a <b>Endossatária</b>, antes da assinatura do presente, realizou sua
                  própria
                  análise de crédito e risco da <span :style="{letterSpacing: LETTER_SPACING}">EMITENTE</span> , da formalização da CCB e eventuais garantias da CCB. Assim,
                  decidiu, por critérios próprios e independentemente da <b>Endossante</b>, adquirir a CCB e tornar-se
                  credor da
                  <span :style="{letterSpacing: LETTER_SPACING}">EMITENTE</span> nas obrigações previstas no referido título.
                </li>
                <li>
                  As <b>Partes</b> estabelecem que após o efetivo pagamento integral do valor devido pela
                  <b>Endossatária</b> pela
                  aquisição da CCB, conforme a Cláusula 2, nada mais será devido por estes à <b>Endossante</b> com relação
                  à
                  aquisição desta CCB, pelo que a <b>Endossante</b> desde já, dá a mais ampla, plena, rasa, geral e
                  irrevogável
                  quitação com relação a referido pagamento
                </li>
                <li>
                  O endosso da CCB é realizado, por meio deste Termo de Endosso: (i) de forma irrevogável e irretratável,
                  abrangendo todas as respectivas obrigações, garantias, privilégios, prerrogativas e demais acessórios;
                  (ii) na modalidade sem coobrigação, bem como sem qualquer retenção de risco, benefício ou
                  responsabilidade, de modo que a <b>Endossante</b> não será responsável solidária  e / ou garantidora do
                  pagamento/liquidez pela Emitente da CCB endossada à <b>Endossatária</b>, assim como não fará jus a
                  qualquer
                  benefício com relação às CCBs após realizado o endosso; e (iii) sem possibilidade de devolução à
                  Endossante pela Endossatária em nenhuma hipótese, inclusive se forem objeto de ações revisionais,
                  reconvenções, embargos ou contestações ou se a CCB for total ou parcialmente contestadas sob qualquer
                  alegação.
                </li>
                <li>
                  A <b>Endossante</b> não responderá pela solvência da Emitente, já que a <b>Endossante</b> não é
                  coobrigada
                  e não
                  há nada na CCB ou no presente Termo de Endosso que implique em coobrigação da <b>Endossante</b>. A
                  <b>Endossatária</b>
                  reconhece, em caráter irrevogável e irretratável, que não possui qualquer direito de ação contra a
                  <b>Endossante</b> diante de eventual inadimplemento da CCB.
                </li>
                <li>
                  O <b>Endossatário</b> tem conhecimento que a <b>Endossante</b> procedeu à análise de crédito e risco
                  necessária para a
                  realização da operação de crédito que resultou na emissão da CCB. Entretanto, o <b>Endossatário</b> fez
                  sua
                  própria análise de crédito e da formalização da CCB, e assim decidiu, por critérios próprios e
                  independentes, adquirir a CCB.
                </li>
                <li>
                  O <b>Endossatário</b> assume todos os riscos advindos do investimento na <b>CCB</b>, já que: (i) foi
                  informado dos riscos envolvidos, e (ii) foi previamente informados do teor da <b>CCB</b>, da forma e
                  métodos de sua formalização e da operação de crédito que esta representa.
                </li>
                <li>
                  Este Termo de Endosso é celebrado em caráter irrevogável e irretratável, obrigando as <b>Partes</b> por
                  si
                  e por seus sucessores a qualquer título.
                </li>
                <li>
                 <div style="">
                   O Endossatário, neste ato, nomeia e constitui, por meio da assinatura desta Carta de Endosso, seu
                    bastante
                    procurador {{ procurador.razao_social }}, pessoa jurídica do direito privado inscrita no CNPJ
                    sob o nº {{ procurador.cnpj }} (o “Outorgado”), outorgando-lhe poderes para, na hipótese de descumprimento,
                    por parte do Emitente, de quaisquer de suas obrigações previstas na CCB ou em documentos apartados
                    relacionados, representar o Endossatário ou indicar/contratar terceiros qualificados para representa-lo
                    em
                    medidas extrajudiciais  e / ou em ação judicial, com o objetivo de recuperar o crédito e defender os
                    direitos
                    patrimoniais dos quais este é titular contra o Emitente, o Avalista e outros responsáveis, conforme
                    aplicável, nos termos da CCB e de documentos apartados relacionados, podendo o Outorgado, para tanto,
                    assinar, juntar e retirar documentos; receber e passar recibos e dar quitação; recorrer, requerer e,
                    além
                    de usar dos poderes das cláusulas ad judicia e extra judicia, confessar, reconhecer a procedência do
                    pedido, acordar, transigir, desistir e renunciar ao direito sobre que se funda a ação; firmar
                    compromissos; discordar; substabelecer, com ou sem reserva de poderes; atuar em conjunto ou
                    separadamente,
                    independentemente de ordem de nomeação, e praticar todos os demais atos que se fizerem necessários para
                    o
                    fiel desempenho do presente mandato.
                 </div>
                  <ol class="nestedList" style="padding-left: 40px;">
                    <li>
                      O Outorgado, ao exercer os poderes ora outorgados, atuará, unicamente, como representante e
                      mandatários do Endossatário, sendo certo que os direitos decorrentes da CCB são de titularidade
                      deste.
                    </li>
                    <li>
                      Em atenção aos poderes outorgados nesta Cláusula 11, após o prazo de 60 (sessenta) dias, contado do
                      vencimento (regular ou antecipado) da CCB, estando o Emitente  e / ou o Avalista inadimplentes em
                      relação
                      a quaisquer de suas obrigações, estará o Outorgado expressamente autorizado a iniciar as medidas de
                      cobrança judicial, conforme entender cabíveis, com o objetivo de recuperar o crédito do qual o
                      Endossatário seja titular em face do Emitente, do Avalista e de outros responsáveis, conforme
                      aplicável. As medidas de cobrança judicial ou extrajudicial, se necessárias, serão conduzidas por
                      escritório de advocacia contratado pelo Outorgado, que substabelecerá o presente mandato. Pelos
                      serviços prestados serão devidos honorários advocatícios, cuja exigibilidade estará condicionada ao
                      êxito das medidas de cobrança; o valor devido pelo Endossatário ao Outorgante ou a terceiros que
                      este
                      venha a constituir, a título de honorários contratuais, observará os seguintes percentuais: na
                      hipótese de recuperação do crédito (integral ou parcialmente) (i) antes da propositura de qualquer
                      medida judicial, 8% (oito por cento) do proveito econômico (valor bruto) obtido em favor do
                      Endossatário; e (ii) após a propositura de qualquer medida judicial, 20% (vinte por cento) do
                      proveito
                      econômico (valor bruto) obtido em favor do Endossatário.

                      <ol>
                        <li>
                          O Outorgado está autorizado a, conforme aplicável, por ocasião do pagamento de valores ao
                          Endossatário, fazer a retenção, a qualquer tempo, do que for devido a título de honorários
                          contratuais e; de reembolso de custas incorridas durante a cobrança. Os valores eventualmente
                          fixados judicialmente a título de honorários de sucumbência em favor dos advogados do
                          Endossatário
                          pertencerão, por direito, exclusivamente aos mesmos
                        </li>
                      </ol>
                    </li>
                    <li>
                      Na hipótese de o Endossatário, por qualquer razão, não desejar ser representado pelo Outorgado,
                      poderá
                      revogar os poderes ora outorgados, por meio de comunicação, em até 60 (sessenta) dias após o
                      vencimento (regular ou antecipado) da CCB; nessa hipótese (de revogação dos poderes do Outorgado) o
                      Endossatário estará livre para adotar as ações que entender convenientes. Não obstante, após o prazo
                      de 60 (sessenta) dias após o vencimento (regular ou antecipado) da CCB, o silêncio do Endossatário
                      implicará a confirmação do mandato ora outorgado e a autorização ao Outorgado  e / ou terceiros por ele
                      indicados para representá-lo nas medidas de cobrança.

                      <ol>
                        <li>
                          Após transcorrido o prazo de 60 dias disponibilizado para revogação do presente mandato, na
                          hipótese de ocorrer qualquer pagamento ao Endossatário em função dos esforços de cobrança
                          realizados, caso o Endossatário decida revogar o mandato ora outorgado sem demonstrar justa
                          causa,
                          os honorários pactuados serão igualmente devidos.
                        </li>
                      </ol>
                    </li>
                    <li>
                      O Endossatário e o Outorgado declaram e concordam que esta Cláusula 11 tem os efeitos de uma
                      procuração geral para o foro, com os poderes especiais acima especificados, servindo de base para a
                      atuação em processos em qualquer foro, fase e em todas as instâncias, em atendimento ao que as leis
                      civis e processuais em vigor determinam.
                    </li>
                    <li>
                      A relação entre o Endossatário e os Outorgados reger-se-á de acordo com as leis brasileiras e ambos
                      se
                      submetem, em caráter irrevogável, à jurisdição exclusiva do Foro da comarca de São Paulo, Estado de
                      São Paulo, para solucionar qualquer disputa ou controvérsia decorrente da sua relação, com a
                      exclusão
                      expressa de qualquer outro foro, por mais privilegiado que seja.
                    </li>

                  </ol>
                </li>
              </ol>
              <br />
              <p>
                E, por estarem assim justas e contratadas, firmam as Partes o presente Termo de Endosso, de forma
                eletrônica.
              </p>

              <p>
                {{ objeto.credor.praca_pagamento }}, {{ objeto.ecwl_aporte.data_extenso }}<br>
              </p>
              <div class="row col-md-12" style="justify-content: center; text-align: center;">
                <div class="col col-md-10 mt-2 mb-2">
                  <hr style="margin-bottom: 0px;">
                  <span :style="{letterSpacing: LETTER_SPACING}">EMITENTE</span>
                </div>
                <div class="col col-md-10">
                  <hr style="margin-bottom: 0px;">
                  ENDOSSANTE
                </div>
                <div class="col col-md-10 mt-2 mb-2">
                  <hr style="margin-bottom: 0px;">
                  ENDOSSATÁRIO
                </div>

              </div>
            </div>

          </div>
        </div>

      </section>
    </vue-html2pdf>
  </div>
</template>

<style lang="scss" scoped>
.download-contrato {
  position: absolute;
  right: 64px;
  top: 10px;

  >div {

    >button {
      font-weight: 600;
      padding: 5 10 5 10;
    }
  }
}

.download-contrato-loading {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.95);
  width: 100%;
  height: 388px;
  top: 0;
  left: 0;
  z-index: 999;
  text-align: center;

  .download-contrato-loading-bounce {
    top: 200px;
  }
}

td {
  padding: 0.35rem;
}

.table-border {
  border: 1px solid #000;

  .title {
    margin-right: 8px;
    /* margin-left: 8px; */
  }

  td {
    border: none;
  }
}

ol.alfaParen {
  counter-reset: list;
}

ol.alfaParen>li {
  list-style: none;
  position: relative;
}

/* li:before {
  content: "(" counter(mycounter, lower-latin) ")";
} */

ol.alfaParen>li:before {
  counter-increment: list;
  content: counter(list, lower-alpha) ") ";
  position: absolute;
  left: -1.4em;
}

ol {
  counter-reset: item;

  li {
    display: block;
    padding-top: 14px;
  }

  li:before {
    content: counters(item, ".") ".";
    counter-increment: item;
  }

}

.ql-editor li:not(.ql-direction-rtl)::before {
  margin-right: 20px;
 }

.termo_endosso {
  font-size: 12px;

}

hr {
  border-top: 1px solid #000;
}
</style>